import { API_BASE_URL } from '../apiClient';

// Skeleton used as a fallback; live metrics are injected from the backend
export const stockSkeleton = [
  {
    id: 'tech',
    name: 'Technology',
    value: 0,
    color: '#8b5cf6',
    type: 'sector',
    children: [
      {
        id: 'software',
        name: 'Software',
        value: 0,
        color: '#a78bfa',
        type: 'industry',
        parent: 'tech',
        children: [
          { id: 'msft', ticker: 'MSFT', name: 'Microsoft', value: 0, color: '#c4b5fd', type: 'stock', parent: 'software' },
          { id: 'googl', ticker: 'GOOGL', name: 'Alphabet', value: 0, color: '#ddd6fe', type: 'stock', parent: 'software' },
          { id: 'orcl', ticker: 'ORCL', name: 'Oracle', value: 0, color: '#c4b5fd', type: 'stock', parent: 'software' },
          { id: 'adbe', ticker: 'ADBE', name: 'Adobe', value: 0, color: '#ddd6fe', type: 'stock', parent: 'software' }
        ]
      },
      {
        id: 'hardware',
        name: 'Hardware',
        value: 0,
        color: '#a78bfa',
        type: 'industry',
        parent: 'tech',
        children: [
          { id: 'aapl', ticker: 'AAPL', name: 'Apple', value: 0, color: '#c4b5fd', type: 'stock', parent: 'hardware' },
          { id: 'nvda', ticker: 'NVDA', name: 'NVIDIA', value: 0, color: '#ddd6fe', type: 'stock', parent: 'hardware' },
          { id: 'intc', ticker: 'INTC', name: 'Intel', value: 0, color: '#e9d5ff', type: 'stock', parent: 'hardware' }
        ]
      },
      {
        id: 'cloud',
        name: 'Cloud Services',
        value: 0,
        color: '#a78bfa',
        type: 'industry',
        parent: 'tech',
        children: [
          { id: 'amzn', ticker: 'AMZN', name: 'Amazon', value: 0, color: '#c4b5fd', type: 'stock', parent: 'cloud' },
          { id: 'crm', ticker: 'CRM', name: 'Salesforce', value: 0, color: '#ddd6fe', type: 'stock', parent: 'cloud' },
          { id: 'snow', ticker: 'SNOW', name: 'Snowflake', value: 0, color: '#e9d5ff', type: 'stock', parent: 'cloud' }
        ]
      }
    ]
  },
  {
    id: 'finance',
    name: 'Finance',
    value: 0,
    color: '#06b6d4',
    type: 'sector',
    children: [
      {
        id: 'banking',
        name: 'Banking',
        value: 0,
        color: '#67e8f9',
        type: 'industry',
        parent: 'finance',
        children: [
          { id: 'jpm', ticker: 'JPM', name: 'JPMorgan', value: 0, color: '#a5f3fc', type: 'stock', parent: 'banking' },
          { id: 'bac', ticker: 'BAC', name: 'Bank of America', value: 0, color: '#cffafe', type: 'stock', parent: 'banking' },
          { id: 'wfc', ticker: 'WFC', name: 'Wells Fargo', value: 0, color: '#ecfeff', type: 'stock', parent: 'banking' }
        ]
      },
      {
        id: 'insurance',
        name: 'Insurance',
        value: 0,
        color: '#67e8f9',
        type: 'industry',
        parent: 'finance',
        children: [
          { id: 'brk', ticker: 'BRK-B', name: 'Berkshire Hathaway', value: 0, color: '#a5f3fc', type: 'stock', parent: 'insurance' },
          { id: 'pgr', ticker: 'PGR', name: 'Progressive', value: 0, color: '#cffafe', type: 'stock', parent: 'insurance' },
          { id: 'aig', ticker: 'AIG', name: 'AIG', value: 0, color: '#ecfeff', type: 'stock', parent: 'insurance' }
        ]
      },
      {
        id: 'fintech',
        name: 'FinTech',
        value: 0,
        color: '#67e8f9',
        type: 'industry',
        parent: 'finance',
        children: [
          { id: 'v', ticker: 'V', name: 'Visa', value: 0, color: '#a5f3fc', type: 'stock', parent: 'fintech' },
          { id: 'ma', ticker: 'MA', name: 'Mastercard', value: 0, color: '#cffafe', type: 'stock', parent: 'fintech' },
          { id: 'pypl', ticker: 'PYPL', name: 'PayPal', value: 0, color: '#ecfeff', type: 'stock', parent: 'fintech' }
        ]
      }
    ]
  },
  {
    id: 'healthcare',
    name: 'Healthcare',
    value: 0,
    color: '#10b981',
    type: 'sector',
    children: [
      {
        id: 'pharma',
        name: 'Pharmaceuticals',
        value: 0,
        color: '#6ee7b7',
        type: 'industry',
        parent: 'healthcare',
        children: [
          { id: 'jnj', ticker: 'JNJ', name: 'Johnson & Johnson', value: 0, color: '#a7f3d0', type: 'stock', parent: 'pharma' },
          { id: 'pfe', ticker: 'PFE', name: 'Pfizer', value: 0, color: '#d1fae5', type: 'stock', parent: 'pharma' },
          { id: 'mrk', ticker: 'MRK', name: 'Merck', value: 0, color: '#ecfdf5', type: 'stock', parent: 'pharma' }
        ]
      },
      {
        id: 'biotech',
        name: 'Biotechnology',
        value: 0,
        color: '#6ee7b7',
        type: 'industry',
        parent: 'healthcare',
        children: [
          { id: 'gild', ticker: 'GILD', name: 'Gilead Sciences', value: 0, color: '#a7f3d0', type: 'stock', parent: 'biotech' },
          { id: 'amgn', ticker: 'AMGN', name: 'Amgen', value: 0, color: '#d1fae5', type: 'stock', parent: 'biotech' },
          { id: 'biib', ticker: 'BIIB', name: 'Biogen', value: 0, color: '#ecfdf5', type: 'stock', parent: 'biotech' }
        ]
      },
      {
        id: 'medtech',
        name: 'Medical Technology',
        value: 0,
        color: '#6ee7b7',
        type: 'industry',
        parent: 'healthcare',
        children: [
          { id: 'mdt', ticker: 'MDT', name: 'Medtronic', value: 0, color: '#a7f3d0', type: 'stock', parent: 'medtech' },
          { id: 'abt', ticker: 'ABT', name: 'Abbott', value: 0, color: '#d1fae5', type: 'stock', parent: 'medtech' },
          { id: 'bax', ticker: 'BAX', name: 'Baxter', value: 0, color: '#ecfdf5', type: 'stock', parent: 'medtech' }
        ]
      }
    ]
  },
  {
    id: 'energy',
    name: 'Energy',
    value: 0,
    color: '#f59e0b',
    type: 'sector',
    children: [
      {
        id: 'oil',
        name: 'Oil & Gas',
        value: 0,
        color: '#fbbf24',
        type: 'industry',
        parent: 'energy',
        children: [
          { id: 'xom', ticker: 'XOM', name: 'ExxonMobil', value: 0, color: '#fcd34d', type: 'stock', parent: 'oil' },
          { id: 'cvx', ticker: 'CVX', name: 'Chevron', value: 0, color: '#fde68a', type: 'stock', parent: 'oil' },
          { id: 'cop', ticker: 'COP', name: 'ConocoPhillips', value: 0, color: '#fef3c7', type: 'stock', parent: 'oil' }
        ]
      },
      {
        id: 'renewable',
        name: 'Renewable Energy',
        value: 0,
        color: '#fbbf24',
        type: 'industry',
        parent: 'energy',
        children: [
          { id: 'nee', ticker: 'NEE', name: 'NextEra Energy', value: 0, color: '#fcd34d', type: 'stock', parent: 'renewable' },
          { id: 'enph', ticker: 'ENPH', name: 'Enphase Energy', value: 0, color: '#fde68a', type: 'stock', parent: 'renewable' },
          { id: 'sedg', ticker: 'SEDG', name: 'SolarEdge', value: 0, color: '#fef3c7', type: 'stock', parent: 'renewable' }
        ]
      }
    ]
  },
  {
    id: 'consumer',
    name: 'Consumer Goods',
    value: 0,
    color: '#ef4444',
    type: 'sector',
    children: [
      {
        id: 'retail',
        name: 'Retail',
        value: 0,
        color: '#f87171',
        type: 'industry',
        parent: 'consumer',
        children: [
          { id: 'wmt', ticker: 'WMT', name: 'Walmart', value: 0, color: '#fca5a5', type: 'stock', parent: 'retail' },
          { id: 'hd', ticker: 'HD', name: 'Home Depot', value: 0, color: '#fecaca', type: 'stock', parent: 'retail' },
          { id: 'tgt', ticker: 'TGT', name: 'Target', value: 0, color: '#fee2e2', type: 'stock', parent: 'retail' }
        ]
      },
      {
        id: 'food',
        name: 'Food & Beverage',
        value: 0,
        color: '#f87171',
        type: 'industry',
        parent: 'consumer',
        children: [
          { id: 'ko', ticker: 'KO', name: 'Coca-Cola', value: 0, color: '#fca5a5', type: 'stock', parent: 'food' },
          { id: 'pep', ticker: 'PEP', name: 'PepsiCo', value: 0, color: '#fecaca', type: 'stock', parent: 'food' },
          { id: 'mdlz', ticker: 'MDLZ', name: 'Mondelez', value: 0, color: '#fee2e2', type: 'stock', parent: 'food' }
        ]
      }
    ]
  }
];

let cachedLiveData = null;

export const fetchLiveStockData = async () => {
  const response = await fetch(`${API_BASE_URL}/stock-data`);
  if (!response.ok) {
    throw new Error('Failed to fetch live stock data');
  }
  const payload = await response.json();
  const data = payload?.data || payload;
  cachedLiveData = data;
  return data;
};

export const getStockData = async (refresh = false) => {
  if (cachedLiveData && !refresh) {
    return cachedLiveData;
  }

  try {
    return await fetchLiveStockData();
  } catch (err) {
    console.warn('Falling back to stock skeleton after live fetch failed', err);
    cachedLiveData = stockSkeleton;
    return cachedLiveData;
  }
};
